import Cookie from 'js.cookie';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // toggles hamburger and nav open and closed states
    var removeClass = true;
    $(".hamburger").click(function () {
      $(".hamburger").toggleClass('is-active');
      $("#sideNav").toggleClass('sideNav-open');
      $(".sideNavBody").toggleClass('sideNavBody-push');
      removeClass = false;
    });

    $(".sideNav").click(function() {
      removeClass = false;
    });

    document.addEventListener('touchstart', function(e) {
      if (removeClass && !$(e.target).hasClass('sideNav') && $('.sideNav').has($(e.target)).length === 0) {
         $(".hamburger").removeClass('is-active');
         $("#sideNav").removeClass('sideNav-open');
         $(".sideNavBody").removeClass('sideNavBody-push');
      }
      removeClass = true;
    }, false);

    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('.scrollup').fadeIn();
      } else {
        $('.scrollup').fadeOut();
      }
    });

    $('.scrollup').click(function () {
      $("html, body").animate({
        scrollTop: 0,
      }, 600);
      return false;
    });

    if (!Cookie.get('alert') && $('#alert').length) {
    $('#alert').slideDown();
  }

  $('.x-btn').click(function() {
    $('#alert').slideUp();
    Cookie.set('alert', true, {
      expires: 1,
    });
  });

    $('.testimonials-container').slick({
      infinite: true,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      nextArrow: '<i class="fas fa-caret-circle-right"></i>',
      prevArrow: '<i class="fas fa-caret-circle-left"></i>',
      appendArrows: '.testimonials .slider-nav',
      appendDots: '.testimonials .slider-nav',
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $('.channels-container').slick({
      infinite: true,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      nextArrow: '<i class="fas fa-caret-circle-right"></i>',
      prevArrow: '<i class="fas fa-caret-circle-left"></i>',
      appendArrows: '.channels .slider-nav',
      appendDots: '.channels .slider-nav',
      slidesToShow: 5,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $(".order-online-btn").click(function() {
      $(".button-links").toggleClass("button-links-active");
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js